import React from 'react';
import HomeView from './components/HomeView/';
import LoginHOC from '../../../../components/LoginHOC';

export default (store) => ({
  component: LoginHOC(HomeView),
});



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Home/index.js